/* Shopify supplies presentment prices in hundredths, including zero-decimal currencies. */
window.FlipzyOfferPricing ||= {
  freeShipping(quantity, subtotal, currency = 'EUR', shopCurrency = 'EUR', presentmentRate = null) {
    if (quantity >= 2) return true;
    // The shipping profile's threshold is EUR 50 after discounts. Shopify's
    // storefront rate converts it to the same hundredths as presentment prices.
    // A missing or mismatched conversion must not turn it into 50 local units.
    if (shopCurrency !== 'EUR') return false;
    const rate = currency === 'EUR' ? 1 : Number(presentmentRate);
    if (!Number.isFinite(rate) || rate <= 0) return false;
    return Number.isFinite(subtotal) && subtotal >= Math.ceil(5000 * rate);
  },
  baseTotals(unitPrice, quantity, currency, enabled = false) {
    const percent = enabled ? (quantity >= 4 ? 20 : quantity >= 3 ? 10 : 0) : 0;
    // Shopify percentage product discounts round the discount down per unit.
    // Native ISK checkout rounds discounts to whole kronur; Ajax still uses hundredths.
    // Other configured markets, including HUF, retain fractional currency units.
    const quantum = currency === 'ISK' ? 100 : 1;
    const unitDiscount = Math.floor((unitPrice * percent) / (100 * quantum)) * quantum;
    const discountedUnitPrice = unitPrice - unitDiscount;
    return { percent, unitPrice: discountedUnitPrice, total: discountedUnitPrice * quantity, saving: unitDiscount * quantity };
  },
};
